/*
 * Copyright 2026 Sergey S. Chernov
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

package net.sergeych.lyng

import net.sergeych.lyng.bytecode.BytecodeStatement
import net.sergeych.lyng.bytecode.CmdVm
import net.sergeych.lyng.bytecode.seedFrameLocalsFromScope
import net.sergeych.lyng.obj.Obj

internal suspend fun executeBytecodeWithSeed(scope: Scope, stmt: Statement, label: String): Obj {
    val bytecode = when (stmt) {
        is BytecodeStatement -> stmt
        is BytecodeBodyProvider -> stmt.bytecodeBody()
        else -> null
    } ?: scope.raiseIllegalState("$label requires bytecode statement")
    scope.pos = bytecode.pos
    bytecode.callOnFast(scope)?.let { return it }
    return CmdVm().execute(bytecode.bytecodeFunction(), scope, scope.args) { frame, _ ->
        seedFrameLocalsFromScope(frame, scope)
    }
}
